import { memoize } from '@softgames/async-utils';
import { AdTimer } from '@softgames/longplay-timer';

// AZ-998: only the 5s warning + trigger; LongPlayAdScheduler owns the interval. Hence 6000/5000.
export const getAdTimer = memoize(() => {
  const adTimer = new AdTimer({
    adRules: {
      startOnCooldown: false,
      adCooldownDuration: 1000,
      adWarningDuration: 5000,
      longPlayTimerDurationMS: 6000,
    },
  });

  adTimer.initialize();

  return adTimer;
});
